<template>
  <div class="exam-box">
    <banner-control></banner-control>
    <div v-if="!isMobile" class="lists">
      <div id="section1" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 8px">01<img
                      src="@/static/images/word-w.png" /></span><span>系统功能强大</span>
                </div>
                <div class="font-14 product-desc__content">
                  <ul>
                    <li class="flex">
                      <span>超快捷安排：</span>
                      <div style="width: 570px">
                        智能题库，灵活组卷、考生/试题一键导入、精准通知、断点续考、监考大厅监控、自动判分，智能统计分析；
                      </div>
                    </li>
                    <li>
                      <span>多场景支持：</span>支持集中考试、随来随考、公开作答、闯关限时作答、刷题训练等12种考试模式；
                    </li>
                    <li>
                      <span>多终端支持：</span>支持PC电脑端、移动端作答，支持全英文系统作答，适用全球的考生；
                    </li>
                    <li>
                      <span>多功能支持：</span>支持在线画图、数学公式、手机拍照答题、上传电脑文件、上传视频等功能；
                    </li>
                    <li class="flex">
                      <span>定制化支持：</span>
                      <div style="width: 570px">
                        支持跟简历系统、OA系统打通，支持Logo、域名个性化定制，强化品牌属性。
                      </div>
                    </li>
                  </ul>
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect" src="@/static/images/exam-sys.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section2" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-2-bg.png" />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 10px">02<img
                      src="@/static/images/word-b.png" /></span><span>多题型支持</span>
                </div>
                <div class="font-14">
                  支持单选、多选、不定项选择、填空、问答、判断、阅读理解、听力、视频、绘图10大题型；<br />
                  在线编程题：赛码自研在线编译系统，可实现在线编程、在线调试、系统自动判题，完美解决IT人才编程技能评定。<br />
                  支持Java/C/C++/JS/Python/C#/PHP/OC/Scratch等20种主流语言。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section3" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 10px">03<img
                      src="@/static/images/word-w.png" /></span><span>AI智能防作弊</span>
                </div>
                <div class="product-desc__content font-14">
                  <ul>
                    <li class="flex">
                      <span>AI抓作弊行为：</span>
                      <div style="width: 550px">
                        赛码AI抓作弊机器人，可识别：打电话、翻书、戴耳机、戴帽子、微信交流、代考、离开座位、多人作答、有异响、多套设备作答等作弊行为，经过人工审查确认，及时警示考生；
                      </div>
                    </li>
                    <li>
                      <span>人脸识别：</span>采用活体检测+人脸识别技术，对接公安部信息系统，考试全程随机抽查，杜绝替考行为；
                    </li>
                    <li class="flex">
                      <span>三机位视频监控：</span>
                      <div style="width: 500px">
                        一机位电脑正面视频、二机位手机侧后方视频、三机位电脑录屏监控；
                      </div>
                    </li>
                    <li>
                      <span>切屏强制交卷：</span>考生切出考试页面，超过规定次数后，系统强制交卷；
                    </li>
                    <li>
                      <span>手机锁屏禁用：</span>考生的手机扫描考试二维码后，考试全程手机被占用，不能做其他使用；
                    </li>
                    <li>
                      <span>试题防作弊：</span>随机抽题、试题乱序、试题水印，禁止复制；
                    </li>
                    <li>
                      <span>雷同比对技术：</span>考后系统自动检测雷同作答，标记疑似作弊。
                    </li>
                  </ul>
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect" src="@/static/images/exam-3-bg.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section4" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-4-bg.png" />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 10px">04<img
                      src="@/static/images/word-b.png" /></span><span>AI智能监考</span>
                </div>
                <div class="font-14">
                  强大的监考大厅，多屏监控画面展现所有考生实时视频，考生的面部表情、一举一动在大屏里实时呈现；<br />
                  AI抓出嫌疑作弊的考生，可进行1对1红牌警告，替考警示，语音警示等；<br />
                  模拟现场人工监考场景，保障远程考试公平公正。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section5" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 8px">05<img
                      src="@/static/images/word-w.png" /></span><span>客户端</span>
                </div>
                <div class="font-14">
                  <ul>
                    <li>满足严格类考试要求，保证考试公平公正；</li>
                    <li>全程实时监测考生异常数据，杜绝考生作弊行为；</li>
                    <li>全面记录考试信息，完整再现考试过程。</li>
                  </ul>
                </div>
                <!-- <a @click="onClient" class="btn" href="javascript:void(0)"
                  >产品试用</a
                > -->
                <a class="btn" href="https://s1.acmcoder.com/release/examclient/client.html" target="_blank">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect5" src="@/static/images/exam-1-bg.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section6" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-5-bg.png" />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 10px">06<img
                      src="@/static/images/word-b.png" /></span><span>系统稳定/支持高并发</span>
                </div>
                <div class="font-14">
                  <ul>
                    <li>
                      赛码系统功能完善、运行稳定、性能可靠，经过数十万企业，数千万次的高并发考试验证，尽管放心使用；
                    </li>
                    <li>
                      系统阿里云部署，弹性云服务器，根据考生人数自动伸缩服务器数量，让30万考生同时在线平稳作答不再是奢望；
                    </li>
                    <li>
                      赛码考试系统通过国家系统等级保护三级评定，高防火墙安全保护；
                    </li>
                    <li>通过严格的权限管理、数据备份等措施，保障数据安全。</li>
                  </ul>
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section7" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 4px">07<img
                      src="@/static/images/word-w.png" /></span><span>专业大题库</span>
                </div>
                <div class="font-14">
                  赛码可按客户要求，进行定制出题服务，题库涵盖：IT研发类，在线编程类，行政能力测试类，金融类，机械类，硬件类，党建类等各方向；目前题库累积试题63+万道。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect5" src="@/static/images/exam-ques.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section8" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-6-bg.png" />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 10px">08<img
                      src="@/static/images/word-b.png" /></span><span>在线测评</span>
                </div>
                <div class="font-14">
                  人才测评和专业能力考核，一场考试即可全部搞定。支持岗位胜任力、团队合作测评、领导力测评、心理风险测评。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section9" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 4px">09<img
                      src="@/static/images/word-w.png" /></span><span>便捷实用的试题判卷</span>
                </div>
                <div class="font-14">
                  支持按试题或按试卷阅卷，支持分组判卷和流水判卷，阅卷官通过自己的账号登录阅卷系统，掌控自己的阅卷进度；<br />
                  支持匿名阅卷，阅卷官无法看到考生信息，避免判卷过程的舞弊行为；<br />
                  题目页面显示答案解析，阅卷官判分后可添加评语。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect5" src="@/static/images/exam-7-bg.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section10" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-8-bg.png" />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 9px">10<img
                      src="@/static/images/word-b.png" /></span><span>准确完善的统计分析</span>
                </div>
                <div class="font-14">
                  可按人员、知识点、学校、职位等维度分析成绩，并生成全维度能力模型报告，让考生各项能力数字化可视化；<br />
                  考后立即生成精准考试报告、成绩单，可导出各类成绩分析报表；<br />
                  自动计算试题通过率和曝光率，助力试题管理和优化。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section11" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num" style="padding-right: 5px">11<img
                      src="@/static/images/word-w.png" /></span><span>特色运营服务</span>
                </div>
                <div class="font-14">
                  赛码可代客户运营考试，设计考试方案、设计试题、录题组卷，导入考生、通知考生，现场监考答疑，考后出具成绩报告等；<br />
                  对于考生量大或者考试组织复杂的项目，赛码有更专业的考试运营团队，为你的考试保驾护航；<br />
                  客户只需把考生名单给我们，剩下的事情都可以放心交给赛码来办。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect9" src="@/static/images/exam-9-bg.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="isMobile-lists">
      <div id="section1" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect" src="@/static/images/exam-sys.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box" style="margin-top: -20px">
                  <div class="product-desc__title">
                    <span class="num" style="padding-right: 12px">01<img
                        src="@/static/images/word-w.png" /></span><span>系统功能强大</span>
                  </div>
                </div>

                <div class="font-14 product-desc__content">
                  <ul>
                    <li>
                      <span>超快捷安排：</span>
                      智能题库，灵活组卷、考生/试题一键导入、精准通知、断点续考、监考大厅监控、自动判分，智能统计分析；
                    </li>
                    <li>
                      <span>多场景支持：</span>

                      支持集中考试、随来随考、公开作答、闯关限时作答、刷题训练等12种考试模式；
                    </li>
                    <li>
                      <span>多终端支持：</span>
                      支持PC电脑端、移动端作答，支持全英文系统作答，适用全球的考生；
                    </li>
                    <li>
                      <span>多功能支持：</span>
                      支持在线画图、数学公式、手机拍照答题、上传电脑文件、上传视频等功能；
                    </li>
                    <li>
                      <span>定制化支持：</span>
                      支持跟简历系统、OA系统打通，支持Logo、域名个性化定制，强化品牌属性。
                    </li>
                  </ul>
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section2" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-2-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title">
                    <span class="num" style="padding-right: 16px">02<img
                        src="@/static/images/word-b.png" /></span><span>多题型支持</span>
                  </div>
                </div>
                <div class="font-14">
                  支持单选、多选、不定项选择、填空、问答、判断、阅读理解、听力、视频、绘图10大题型；<span v-if="!isMobile"><br /></span>
                  在线编程题：赛码自研在线编译系统，可实现在线编程、在线调试、系统自动判题，完美解决IT人才编程技能评定。<span v-if="!isMobile"><br /></span>支持Java/C<span
                    v-if="isMobile"><br /></span>/C++/JS/Python/C#/PHP/OC/Scratch等20种主流语言。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section3" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect" src="@/static/images/exam-3-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top: -10px">
                    <span class="num" style="padding-right: 16px">03<img
                        src="@/static/images/word-w.png" /></span><span>AI智能防作弊</span>
                  </div>
                </div>
                <div class="product-desc__content font-14">
                  <ul>
                    <li>
                      <span>AI抓作弊行为：</span>
                      赛码AI抓作弊机器人，可识别：打电话、翻书、戴耳机、戴帽子、微信交流、代考、离开座位、多人作答、有异响、多套设备作答等作弊行为，经过人工审查确认，及时警示考生；
                    </li>
                    <li>
                      <span>人脸识别：</span>
                      采用活体检测+人脸识别技术，对接公安部信息系统，考试全程随机抽查，杜绝替考行为；
                    </li>
                    <li>
                      <span>三机位视频监控：</span>
                      一机位电脑正面视频、二机位手机侧后方视频、三机位电脑录屏监控；
                    </li>
                    <li>
                      <span>切屏强制交卷：</span>
                      考生切出考试页面，超过规定次数后，系统强制交卷；
                    </li>
                    <li>
                      <span>手机锁屏禁用：</span>
                      考生的手机扫描考试二维码后，考试全程手机被占用，不能做其他使用；
                    </li>
                    <li>
                      <span>试题防作弊：</span>
                      随机抽题、试题乱序、试题水印，禁止复制；
                    </li>
                    <li>
                      <span>雷同比对技术：</span>
                      考后系统自动检测雷同作答，标记疑似作弊。
                    </li>
                  </ul>
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section4" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-4-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top: -10px">
                    <span class="num" style="padding-right: 16px">04<img
                        src="@/static/images/word-b.png" /></span><span>AI智能监考</span>
                  </div>
                </div>
                <div class="font-14">
                  强大的监考大厅，多屏监控画面展现所有考生实时视频，考生的面部表情、一举一动在大屏里实时呈现；<br />
                  AI抓出嫌疑作弊的考生，可进行1对1红牌警告，替考警示，语音警示等；<br />
                  模拟现场人工监考场景，保障远程考试公平公正。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section5" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect5" src="@/static/images/exam-1-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top: -5px; font-size: 26px">
                    <span class="num" style="padding-right: 15px">05<img
                        src="@/static/images/word-w.png" /></span><span>客户端</span>
                  </div>
                </div>
                <div class="font-14">
                  <ul>
                    <li>满足严格类考试要求，保证考试公平公正；</li>
                    <li>全程实时监测考生异常数据，杜绝考生作弊行为；</li>
                    <li>全面记录考试信息，完整再现考试过程。</li>
                  </ul>
                </div>
                <div class="center-box">
                  <!-- <a @click="onClient" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  > -->
                  <a class="btn" href="javascript:void(0)">敬请期待</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section6" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-5-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title">
                    <span class="num" style="padding-right: 16px">06<img
                        src="@/static/images/word-b.png" /></span><span>系统稳定/支持高并发</span>
                  </div>
                </div>
                <div class="font-14">
                  <ul>
                    <li>
                      赛码系统功能完善、运行稳定、性能可靠，经过数十万企业，数千万次的高并发考试验证，尽管放心使用；
                    </li>
                    <li>
                      系统阿里云部署，弹性云服务器，根据考生人数自动伸缩服务器数量，让30万考生同时在线平稳作答不再是奢望；
                    </li>
                    <li>
                      赛码考试系统通过国家系统等级保护三级评定，高防火墙安全保护；
                    </li>
                    <li>通过严格的权限管理、数据备份等措施，保障数据安全。</li>
                  </ul>
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section7" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect5" src="@/static/images/exam-ques.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top: -5px">
                    <span class="num" style="padding-right: 12px">07<img
                        src="@/static/images/word-w.png" /></span><span>专业大题库</span>
                  </div>
                </div>
                <div class="font-14">
                  赛码可按客户要求，进行定制出题服务，题库涵盖：IT研发类，在线编程类，行政能力测试类，金融类，机械类，硬件类，党建类等各方向；目前题库累积试题63+万道。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section8" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-6-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title">
                    <span class="num" style="padding-right: 15px">08<img
                        src="@/static/images/word-b.png" /></span><span>在线测评</span>
                  </div>
                </div>
                <div class="font-14">
                  人才测评和专业能力考核，一场考试即可全部搞定。支持岗位胜任力、团队合作测评、领导力测评、心理风险测评。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section9" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect9" src="@/static/images/exam-7-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top:90px">
                    <span class="num" style="padding-right: 13px">09<img
                        src="@/static/images/word-w.png" /></span><span>便捷实用的试题判卷 </span>
                  </div>
                </div>
                <div class="font-14">
                  支持按试题或按试卷阅卷，支持分组判卷和流水判卷，阅卷官通过自己的账号登录阅卷系统，掌控自己的阅卷进度；<br />
                  支持匿名阅卷，阅卷官无法看到考生信息，避免判卷过程的舞弊行为；<br />
                  题目页面显示答案解析，阅卷官判分后可添加评语。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section10" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect2" src="@/static/images/exam-8-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="padding-top: 15px">
                    <span class="num" style="padding-right: 15px">10<img
                        src="@/static/images/word-b.png" /></span><span>准确完善的统计分析</span>
                  </div>
                </div>
                <div class="font-14">
                  可按人员、知识点、学校、职位等维度分析成绩，并生成全维度能力模型报告，让考生各项能力数字化可视化；<br />
                  考后立即生成精准考试报告、成绩单，可导出各类成绩分析报表；<br />
                  自动计算试题通过率和曝光率，助力试题管理和优化。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section11" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img class="product-desc__sketch effect effect9" src="@/static/images/exam-9-bg.png" />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="center-box">
                  <div class="product-desc__title" style="margin-top: -20px">
                    <span class="num" style="padding-right: 13px">11<img
                        src="@/static/images/word-w.png" /></span><span>特色运营服务 </span>
                  </div>
                </div>
                <div class="font-14">
                  赛码可代客户运营考试，设计考试方案、设计试题、录题组卷，导入考生、通知考生，现场监考答疑，考后出具成绩报告等；<br />
                  对于考生量大或者考试组织复杂的项目，赛码有更专业的考试运营团队，为你的考试保驾护航；<br />
                  客户只需把考生名单给我们，剩下的事情都可以放心交给赛码来办。
                </div>
                <div class="center-box">
                  <a @click="goTest" class="btn" href="javascript:void(0)">产品试用</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isMobile" class="exam-footer b-box">
      <div class="text-box">
        <div class="title">更多特色功能</div>
        <ul>
          <li>
            <div class="img"><img src="@/static/images/exam-10-1-bg.png" /></div>
            <div class="text">报名审核</div>
            <div class="font-14">
              每场考试可支持自定义考试报名表，可选用丰富的字段类型，支持报名人工审核，审核通过的考生，可在线支付报名费。
            </div>
          </li>
          <li>
            <div class="img"><img src="@/static/images/exam-10-2-bg.png" /></div>
            <div class="text">现场考试编排</div>
            <div class="font-14">
              如果是线下的考试形式，赛码支持按照不同考场/不同座位号，自动生成每个考生的准考证，考官依据考生名单在考场入口核查身份签到，现场考生按座位号就坐，即可进行现场的考试。
            </div>
          </li>
          <li>
            <div class="img"><img src="@/static/images/exam-10-3-bg.png" /></div>
            <div class="text">在线编程考试</div>
            <div class="font-14">
              针对IT/互联网行业的编程人员，赛码考试系统可以专业地测评出考生的编程水平，通过对考生作答试题的代码运行，系统会自动出具该考生的编程水平综合分析报告。
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div v-if="isMobile" class="mobile-exam-footer b-box">
      <div class="text-box">
        <div class="title">更多特色功能</div>
        <li>
          <div class="img"><img src="@/static/images/exam-10-2-bg.png" /></div>
          <div class="text">现场考试编排</div>
          <div class="font-14">
            如果是线下的考试形式，赛码支持按照不同考场/不同座位号，自动生成每个考生的准考证，考官依据考生名单在考场入口核查身份签到，现场考生按座位号就坐，即可进行现场的考试。
          </div>
        </li>
        <li>
          <div class="img"><img src="@/static/images/exam-10-3-bg.png" /></div>
          <div class="text">在线编程考试</div>
          <div class="font-14">
            针对IT/互联网行业的编程人员，赛码考试系统可以专业地测评出考生的编程水平，通过对考生作答试题的代码运行，系统会自动出具该考生的编程水平综合分析报告。
          </div>
        </li>
        <li>
          <div class="img"><img src="@/static/images/exam-10-1-bg.png" /></div>
          <div class="text">报名审核</div>
          <div class="font-14">
            每场考试可支持自定义考试报名表，可选用丰富的字段类型，支持报名人工审核，审核通过的考生，可在线支付报名费。
          </div>
        </li>
      </div>
    </div>
    <examFooter></examFooter>
    <us-pc-dialog :dialogVisible="isPcDialogShow" @cancel="isPcDialogShow = false" />
  </div>
</template>

<script>
import bannerControl from '@/components/product/exam/banner.vue'
import textBg from '@/components/product/exam/text-bg.vue'
import examFooter from '@/components/product/exam/footer.vue'

export default {
  components: {
    bannerControl,
    textBg,
    examFooter,
  },
  data() {
    return { isMobile: false, isPcDialogShow: false }
  },
  created() {
    this.isMobile = this.$store.state.app.device
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          this.toPage()
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
    chatShow() {
      this.$bus.emit('chatShow')
    },
    onClient() {
      window.open('https://s1.acmcoder.com/release/examclient/client.html')
    },
    toPage() {
      let toPage = this.$route.query.to
      if (toPage) {
        window.scrollTo(0, document.getElementById(toPage).offsetTop)
      } else {
        window.scrollTo(0, 0)
      }
      this.$route.query.to = ''
    },
  },
  mounted() {
    this.toPage()
  },
}
</script>

<style lang="scss" scoped>
.main-box {
  width: 100%;
  overflow-x: hidden;
}
.section {
  overflow-x: hidden;
}
.b-box {
  background: #f7f8fd url('/static/images/bbg.png') repeat-x;
}
.w-box {
  background: #fff url('/static/images/wbg.png') repeat-x;
}
.intro-card {
  display: flex;
  justify-content: center;
  padding: 70px 20px 60px;
  min-height: 550px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0px auto;
  display: flex;
  .intro-card__left {
    width: 700px;
    .product-desc {
      width: 100%;
      text-align: left;
      a {
        margin-top: 30px;
      }
      .product-desc__title {
        margin: 20px 0 40px;
        font-size: 36px;
        color: #000000;
        .num {
          font-size: 54px;
          font-weight: blod;
          font-family: DIN;
          padding-right: 12px;

          position: relative;
          top: 8px;
          margin: 0px 10px 0px 0px;
          img {
            position: absolute;
            bottom: 1px;

            padding-bottom: 6px;
            right: 0px;
          }
        }
      }
      .product-desc__num {
        position: relative;
        margin-right: 15px;
        top: 10px;
        vertical-align: bottom;
      }
      .product-desc__content {
        span {
          color: #29bdb9;
          font-size: 14px;
          font-weight: bold;
          display: inline;
        }
      }
    }
  }
  .intro-card__right {
    width: 500px;
  }
}
.paradigm_sketch {
  position: relative;
  .effect {
    position: absolute;
    top: 50px;
    left: 58px;
    z-index: 9;
    width: 400px;
  }
  .effect2 {
    width: 300px;
    left: 117px;
    top: 100px;
  }
  .effect5 {
    width: inherit;
    height: 300px;
    left: 120px;
    top: 80px;
  }
}
.exam-footer {
  padding: 50px 0px 40px;
  .text-box {
    max-width: 1200px;
    margin: 0px auto;
  }
  .title {
    text-align: center;
    font-size: 30px;
  }
  ul {
    display: flex;
    margin: 80px 0 20px 0;
    li {
      width: 30%;
      text-align: center;
      &:nth-child(2) {
        width: 40%;
        padding: 0px 3%;
      }
      .text {
        padding: 10px 0px;
        font-weight: 300;
        font-size: 20px;
      }
    }
  }
}
.isMobile-lists {
  .intro-card {
    width: initial;
    display: inline-block;
    padding: 0 20px 20px 20px;
    margin-top: -30px;
    .intro-card__left {
      width: initial;
      padding-left: 10px;
      margin-top: -50px;
      .product-desc {
        padding: 0px;
        .product-desc__title {
          margin: 20px auto;
          font-size: 28px;
          .num {
            font-size: 40px;
          }
        }
        .center-box {
          text-align: center;
          .btn {
            margin-top: 20px;
          }
        }
      }
    }
    .intro-card__right {
      width: 0px;
      margin-left: -8px;
      .paradigm_sketch {
        margin-left: 0 !important;
      }
    }
  }
  .section {
    .intro-card__left {
      float: left;
    }
    .intro-card__right {
      .paradigm_sketch {
        transform: scale(0.7);
        margin-left: -70px;
      }
    }
  }
}
.mobile-exam-footer {
  text-align: center;
  padding: 20px;
  .title {
    font-size: 28px;
    color: #000;
    padding: 20px;
    font-weight: 350;
  }
  .text {
    padding: 20px;
    font-size: 24px;
  }
  .font-14 {
    text-align: left;
  }
}
</style>
<style lang="scss">
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .isMobile-lists {
    .section {
      text-align: center;
    }
    .b-box,
    .w-box {
      text-align: center;
    }
    .intro-card {
      width: 700px !important;
      text-align: center;
      .intro-card__right {
        width: 350px !important;

        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .mobile-exam-footer {
    .font-14 {
      width: 700px;
      margin: auto;
      padding-bottom: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/exam.vue